import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_377: DocMigration = {
  maxSchemaVersion: "0.0.377",
  description: "Rename SLAB_LABELS and CASEWORK_LABELS to SLAB_TAG and CASEWORK_TAG",
  apply(json: any) {
    for (const viewTemplateId in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[viewTemplateId];
      for (const categoryId in viewTemplate.categories) {
        if (viewTemplate.categories[categoryId] === "SLAB_LABELS") {
          json.viewTemplates[viewTemplateId].categories[categoryId] = "SLAB_TAG";
        }
        if (viewTemplate.categories[categoryId] === "CASEWORK_LABELS") {
          json.viewTemplates[viewTemplateId].categories[categoryId] = "CASEWORK_TAG";
        }
      }
    }
    return json;
  },
};

export default migration_0_0_377;
